import React, { useRef, useState } from 'react';
import Quote from './Quote';
import useDailyQuote from '../hooks/useDailyQuote';
import useStreak from '../hooks/useStreak';
import useFavorites from '../hooks/useFavorites';

const DailyQuote = () => {
    const { quote, loading, error } = useDailyQuote();
    const streak = useStreak();
    const { isFavorited, toggleFavorite } = useFavorites();
    const [shareStatus, setShareStatus] = useState('');
    const shareTimerRef = useRef(null);

    const handleShare = async () => {
        if (!quote) return;
        const text = `"${quote.text}" — ${quote.author}`;
        if (navigator.share) {
            try { await navigator.share({ title: 'Quote of the Day', text, url: window.location.href }); }
            catch {}
        } else {
            try {
                await navigator.clipboard.writeText(text);
                setShareStatus('Copied!');
            } catch {
                setShareStatus('Unable to copy.');
            }
        }
        clearTimeout(shareTimerRef.current);
        shareTimerRef.current = setTimeout(() => setShareStatus(''), 3000);
    };

    return (
        <div className="daily-section">
            <div className="daily-header">
                <span className="daily-label">Quote of the Day</span>
                <span className="streak-badge">Day {streak}</span>
            </div>
            {loading && <p className="status-text">Loading...</p>}
            {error && <p className="error-text">{error}</p>}
            {!loading && !error && quote && (
                <Quote
                    quote={quote}
                    liked={isFavorited(quote)}
                    onLike={() => toggleFavorite(quote)}
                    onShare={handleShare}
                />
            )}
            {shareStatus && <p className="share-status">{shareStatus}</p>}
        </div>
    );
};

export default DailyQuote;
